export default __webpack_public_path__ + "static/dark-blue-59ecc672bef0ab029efbe23ff636689e.png";